module.exports = __webpack_public_path__ + "img/h_b_bg2.8baebac0.png";